export default "__VITE_ASSET__CKSIw63S__ 500w";